import React, { useState } from 'react';
import { EventsTable } from 'src/domains/sportsbook/webview/components/eventsTable/EventsTable';
import { computed, makeObservable } from 'mobx';
import { EventsCollectionList } from 'src/domains/sportsbook/state/eventsCollection/EventsCollectionList';
import { observer } from 'src/utils/mobx-react';
import { EventsTableHeaderStyle } from 'src/domains/sportsbook/webview/components/eventsTable/EventsMainSectionWrapper';
import { Common, useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { EventsCollectionState } from 'src/domains/sportsbook/state/eventsCollection/EventsCollectionState';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { HomepageUnifiedEventsSection } from 'src/domains/sportsbook/webview/components/containers/homepageUnifiedEventsSection/HomepageUnifiedEventsSection';
import { FiltersSkin } from 'src/domains/layouts/webview/components/filters/FiltersSkin';
import { isSpecialOutrightEventItem, isValidEventItem } from 'src/domains/sportsbook/utils/isOutrightEvent';

class EventsStartingSoonState {
    public constructor(private readonly common: Common) {
        makeObservable(this);
    }

    @computed public get eventsCollection(): EventsCollectionList {
        const { unifiedSportEventsTable } = ConfigComponents.get(this.common).unifiedComponentConfig;
        const listStartingSoon = EventsCollectionState.get(this.common).listStartingSoon;

        return unifiedSportEventsTable
            ? listStartingSoon.filterBySportAndEvent(
                  (_sport, event): boolean => isValidEventItem(event) && !isSpecialOutrightEventItem(event)
              )
            : listStartingSoon;
    }

    public get tableLabel(): string {
        return LanguagesState.get(this.common).getTranslation('special-box.header.starting-soon', 'Starting soon');
    }
}

interface PropsType {
    showPriceLegend: boolean;
}

export const EventsStartingSoon = observer('EventsStartingSoon', ({ showPriceLegend }: PropsType) => {
    const common = useCommon();
    const { unifiedSportEventsTable, filtersVersion } = ConfigComponents.get(common).unifiedComponentConfig;
    const [upcomingState] = useState(() => new EventsStartingSoonState(common));
    const { eventsCollection, tableLabel } = upcomingState;
    const isLoading = eventsCollection.isLoading;

    if (unifiedSportEventsTable) {
        return (
            <HomepageUnifiedEventsSection
                collection={eventsCollection}
                dataTest='starting-soon'
                filters={['sport']}
                filterVersion={FiltersSkin.TERTIARY}
                hideWhenEmpty={true}
                isLoading={isLoading}
                showPriceLegend={showPriceLegend}
                title={tableLabel}
            />
        );
    }

    return (
        <EventsTable
            headerStyle={EventsTableHeaderStyle.SOLID}
            filterVersion={filtersVersion.startingSoon}
            icon='in-play'
            className='events-table--in-play events-table--dark'
            title={tableLabel}
            showHeaderSport={true}
            allGroupsOpen={true}
            eventsCollection={eventsCollection}
            isTogglable={true}
            showPriceLegend={showPriceLegend}
            filters={[]}
            isLoading={isLoading}
            hideNoEventsMessage={true}
            dataTest='starting-soon'
            isAmericanFootball={false}
        />
    );
});
